import type { Task, TaskCreate, TaskUpdate } from '../types/task';
import { fetcher } from '../utils/fetcher';

const API_URL = '/api/v1/tasks';

export const getTasks = async (projectId?: number, milestoneId?: string): Promise<Task[]> => {
    let url = `${API_URL}/read`;
    const params = new URLSearchParams();
    
    if (projectId) {
        params.append('project_id', projectId.toString());
    }
    if (milestoneId) {
        params.append('milestone_id', milestoneId);
    }
    
    if (params.toString()) {
        url += `?${params.toString()}`;
    }

    const response = await fetcher(url);
    return response;
};

// NOTE: getTasks(projectId, ...) sends ?project_id= but the backend /tasks/read
// only honors milestone_id, so the project_id query is ignored. Use this instead
// to fetch a project's tasks (backend exposes them via a path route).
export const getTasksByProject = async (projectId: string): Promise<Task[]> => {
    const response = await fetcher(`${API_URL}/read/${projectId}`);
    return response;
};

// There is no backend single-task endpoint (/read/{id} is the project-tasks route),
// so fetch all and find. Refresh-safe and fine at the current scale.
export const getTaskById = async (taskId: string): Promise<Task | undefined> => {
    const all = await getTasks();
    return all.find(t => t.id === taskId);
};

export const createTask = async (task: TaskCreate): Promise<Task> => {
    const response = await fetcher(`${API_URL}/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(task),
    });
    return response;
};

export const updateTask = async (taskId: string, updates: TaskUpdate): Promise<Task> => {
    const response = await fetcher(`${API_URL}/update/${taskId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates),
    });
    return response;
};

export const deleteTask = async (taskId: string): Promise<boolean> => {
    const response = await fetcher(`${API_URL}/delete/${taskId}`, {
        method: 'DELETE',
    });
    return response;
};